import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { applyPolyfills, defineCustomElements } from '@se/web-ui/loader';
import { addCustomEventPolyfill } from './utils/polyfills';
import { registerIconLibrary } from '@quartzds/core-react'

class ComparisonPage extends HTMLElement {
    constructor() {
        super();

        const mountPoint = document.createElement('div');
        mountPoint.id = 'app';
        this.appendChild(mountPoint);

        const brand = this.getAttribute('brand');
        const isPublic = this.getAttribute('is-public') === 'true';
        let countryCode = this.getAttribute('country-code');
        let languageCode = this.getAttribute('language-code');
        const pageRoute = this.getAttribute('page-route');

        if (process.env.REACT_APP_DEV === 'mock'){
            countryCode = 'US';
            languageCode = 'en';
        }

        const bazaarVoiceEnabled = window.bvEnabled || false;

        ReactDOM.hydrate(
            (
                <App
                    isPublic={isPublic}
                    contextRoot={brand ? `/${brand}` : ''}
                    countryCode={countryCode}
                    languageCode={languageCode}
                    bazaarVoiceEnabled={bazaarVoiceEnabled}
                    pageRoute={pageRoute}
                />
            ),
            mountPoint,
            () => {
                this.setAttribute('class', 'hydrated');
            }
        );
    }
}

customElements.define('comparison-page', ComparisonPage);

applyPolyfills().then(defineCustomElements);
addCustomEventPolyfill();

registerIconLibrary('core', {
  resolver: (name) =>
      `https://d2osz8slymlqdp.cloudfront.net/@quartzds/se-icons-core/@1.0.0-beta.8/dist/${name}.svg`,
});
registerIconLibrary('default', {
  resolver: (name) =>
      `https://d2osz8slymlqdp.cloudfront.net/@quartzds/se-icons-general/@1.0.0-beta.13/dist/${name}.svg`,
});

